'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

const ApplicationOverview: React.FC = () => {
	return (
		<section className={styles.applicationOverview}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation='slideUp'>
						<div className={styles.subtitle}>Обзор приложения</div>
						<h2
							className={styles.title}
							dangerouslySetInnerHTML={{
								__html: '<span>True.pay B2С — безопасные выплаты</span> в один клик под вашим полным контролем'
							}}
						/>
					</AnimatedSection>

					<AnimatedSection animation='slideUp'>
						<div className={styles.description}>
							<p className={styles.paragraph}>
							True.pay B2C — это веб-приложение <span>для быстрых и безопасных переводов</span> от юридических лиц физическим напрямую с бизнес-карты.</p>
							<p className={styles.paragraph}>
							Сервис разработан как <span>безопасная альтернатива стандартному интернет-банку.</span> Он исключает необходимость постоянного входа в СберБизнес и полностью изолирует операционную рутину выплат от управления главными финансовыми потоками компании.
						</p>
						</div>
					</AnimatedSection>
				</div>

				<AnimatedSection animation='slideUp'>
					<div className={styles.imageContainer}>
						<Image
							src='/images/b2c/applictaion_desktop.png'
							alt='Обзор приложения True.pay B2C'
							width={1110}
							height={600}
							className={styles.desktopImage}
							unoptimized
						/>
						<Image
							src='/images/b2c/applictaion_tablet.png'
							alt='Обзор приложения True.pay B2C'
							width={680}
							height={368}
							className={styles.tabletImage}
							unoptimized
						/>
						<Image
							src='/images/b2c/applictaion_mobile.png'
							alt='Обзор приложения True.pay B2C'
							width={328}
							height={294}
							className={styles.mobileImage}
							unoptimized
						/>
					</div>
				</AnimatedSection>
			</div>
		</section>
	)
}

ApplicationOverview.displayName = 'ApplicationOverview'

export default ApplicationOverview
